module.exports = __webpack_public_path__ + "img/poster-stray.f991964a.png";